/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Material_Add_LabelInputs */



/**
* | output |
* | --- |
* | "Paste notes" |
*
* @param {Meeting_Report_Material_Add_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_material_add_label = /** @type {((inputs?: Meeting_Report_Material_Add_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Material_Add_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notities plakken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller des notes")
	return /** @type {LocalizedString} */ ("Paste notes")
});